import React from 'react'
import { Form, Input, Button, Card } from "antd";

interface TokenInputParams {
    requestPollInfo: (values: {
        vote_token: string;
    }) => void,
    saveVoteToken: (input: string) => void
    
}

const TokenInput:React.FC<TokenInputParams> = ( { requestPollInfo, saveVoteToken} ) => {
    const onFinish = (values: {vote_token: string}) => {
        saveVoteToken(values.vote_token)
        requestPollInfo(values)
    };

      /////// Any? //////
      const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    return(
        <div className='vote_content_card'>
            <Card title="Vote" className='vote_card_inner'>
                <Form
                    name="basic"
                    wrapperCol={{
                        span: 24,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off" >
                    
                    <Form.Item
                        name="vote_token">
                        <Input placeholder="Enter vote token" />
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                        offset: 0,
                        span: 24,
                        }}>
                        <Button block type="primary" htmlType="submit">
                            Get Ballot
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div> 
    )
}

export default TokenInput